import { Environment } from "@core/config/environment";
import { ArticleStatus } from "@domain/lms/article/article";
import { CourseStatus } from "@domain/lms/course/courseDraft";

const jaangalColors = {
	primary: "#00863A",
	primaryTouch: "#01652C",
	primaryLight: "#E4F2EB",
	primaryLightTouch: "#C9DDD2",

	thirded: "#00863A",
	lightthirded: "#01652C",
	thirdedouch: "#01652C",
	thirdedLight: "#E4F2EB",
	thirdedLightTouch: "#C9DDD2",

	secondary: "#00863B",
	secondaryTouch: "#01652C",
	secondaryLight: "#E5F3EA",
	secondaryLightTouch: "#BED2F6",

	tertiaryblue: "#E8F0FF",

	white: "#ffffff",
	black: "#000000",
	lightgray: "#d1d1d1",
	simplegray: "#F3F4F6",
	lightergray: "#eaebef",
	gray: "#b2b2b2",
	darkgray: "#6F6F6F",
	bodyBackground: "#F1F1F1",
	backgroundPrimary: "#ffffff",

	textPrimary: "#13131a",
	textSecondary: "#6f6f6f",
	textTertiary: "#b2b2b2",

	green: "#40d19d",
	winterGreen: "#00D415",
	orange: "#fbb513",
	red: "#E83636",
	lightRed: "#FFDCDC",
	link: "#5e93c5",
	lightBlue: "#bedaff",
	lightOrange: "#ffd3be",
	lightGreen: "#adeed1",
	lightPurple: "#cbadee",
	vividBlue: "#569fff",
	vividOrange: "#fbae86",
	warning: "#FDF4DB",
	warningBold: "#FBB513",
	vividGreen: "#3ad18e",
	vividPurple: "#c19deb",
	articleDetailsColor: "#564f4f",
	workspaceHeaderColor: "#C3D9FC",
	articleColor: "#ec5d57",
	liveDescrription: "#0D0E12",
	primaryGradient: "270.44deg, #1FA3C0 3.77%, rgba(61, 176, 170, 0.84) 110%",
	secondaryGradient: "90.75deg, rgba(245, 72, 48, 0.9) -26.25%, #FCAD14 97.05%",
	thirdGradient: "269.98deg, #7248E9 3.59%, #BD88C6 138.34%",
	fourthGradient: "270.02deg, #ED767E 3.59%, #E6323E 102.06%",

	primaryGradientLight: "270.44deg, rgba(31, 163, 192, 0.05) 3.77%, rgba(61, 176, 170, 0.042) 110%",
	secondaryGradientLight: "90.75deg, rgba(245, 72, 48, 0.045) -26.25%, rgba(252, 173, 20, 0.05) 97.05%",
	thirdGradientLight: "269.98deg, rgba(114, 72, 233, 0.05) 3.59%, rgba(189, 136, 198, 0.05) 138.34%",
	fourthGradientLight: "270.02deg, rgba(237, 118, 126, 0.07) 3.59%, rgba(230, 50, 62, 0.07) 102.06%",
} as const;

const tooshareColors = {
	primary: "#E83636",
	primaryTouch: "#DB1C1C",
	primaryLight: "#FFDCDC",
	primaryLightTouch: "#FDCCCC",

	secondary: "#206AF8",
	secondaryTouch: "#1157DF",
	secondaryLight: "#D2E1FC",
	secondaryLightTouch: "#BED2F6",

	thirded: "#FBB513",
	lightthirded: "#FFB200",
	thirdedouch: "#DB1C1C",
	thirdedLight: "#FFDCDC",
	thirdedLightTouch: "#e9d096",

	tertiaryblue: "#E8F0FF",

	white: "#ffffff",
	black: "#000000",
	lightgray: "#d1d1d1",
	simplegray: "#F3F4F6",
	lightergray: "#eaebef",
	gray: "#b2b2b2",
	darkgray: "#6F6F6F",
	bodyBackground: "#F1F1F1",
	backgroundPrimary: "#ffffff",

	textPrimary: "#13131a",
	textSecondary: "#6f6f6f",
	textTertiary: "#b2b2b2",

	green: "#40d19d",
	winterGreen: "#00D415",
	orange: "#fbb513",
	red: "#E83636",
	lightRed: "#FFDCDC",
	link: "#5e93c5",
	lightBlue: "#bedaff",
	lightOrange: "#ffd3be",
	lightGreen: "#adeed1",
	lightPurple: "#cbadee",
	vividBlue: "#569fff",
	vividOrange: "#fbae86",
	warning: "#FDF4DB",
	warningBold: "#FBB513",
	vividGreen: "#3ad18e",
	vividPurple: "#c19deb",
	articleDetailsColor: "#564f4f",
	workspaceHeaderColor: "#C3D9FC",
	articleColor: "#ec5d57",
	liveDescrription: "#0D0E12",
	primaryGradient: "270.44deg, #1FA3C0 3.77%, rgba(61, 176, 170, 0.84) 110%",
	secondaryGradient: "90.75deg, rgba(245, 72, 48, 0.9) -26.25%, #FCAD14 97.05%",
	thirdGradient: "269.98deg, #7248E9 3.59%, #BD88C6 138.34%",
	fourthGradient: "270.02deg, #ED767E 3.59%, #E6323E 102.06%",

	primaryGradientLight: "270.44deg, rgba(31, 163, 192, 0.05) 3.77%, rgba(61, 176, 170, 0.042) 110%",
	secondaryGradientLight: "90.75deg, rgba(245, 72, 48, 0.045) -26.25%, rgba(252, 173, 20, 0.05) 97.05%",
	thirdGradientLight: "269.98deg, rgba(114, 72, 233, 0.05) 3.59%, rgba(189, 136, 198, 0.05) 138.34%",
	fourthGradientLight: "270.02deg, rgba(237, 118, 126, 0.07) 3.59%, rgba(230, 50, 62, 0.07) 102.06%",
} as const;

export const colors = Environment.APP_VARIANT === "jaangal" ? jaangalColors : tooshareColors;

export const courseStatusColor: { [key in CourseStatus | "ALL"]: string } = {
	ARCHIVED: colors.orange,
	DRAFT: colors.gray,
	PUBLISHED: colors.green,
	ALL: colors.textPrimary,
};

export const articleStatusColor: { [key in ArticleStatus | "ALL"]: string } = {
	ARCHIVED: colors.orange,
	DRAFT: colors.gray,
	PUBLISHED: colors.green,
	ALL: colors.textPrimary,
};

export const liveColors = [colors.white] as const;
export const workspaceColors = [colors.lightBlue, colors.lightOrange, colors.lightGreen, colors.lightPurple] as const;
export const quizColors = [colors.vividBlue, colors.vividOrange, colors.vividGreen, colors.vividPurple] as const;

export type Colors = typeof colors;
